import React from "react";
import Header from "@/components/Header";
import IncomeCard from "@/components/IncomeCard";
import { usePeriod } from "@/contexts/PeriodContext";

export default function IncomesPage() {
  const { month, year, view, setMonth, setYear, setView, refreshKey, bump } = usePeriod();
  return (
    <div className="min-h-screen">
      <Header
        month={month}
        year={year}
        view={view}
        setMonth={setMonth}
        setYear={setYear}
        setView={setView}
        title="ניהול הכנסות"
        backTo="/app"
      />
      <main className="max-w-6xl mx-auto px-4 md:px-8 py-8">
        <IncomeCard
          month={month}
          year={year}
          refreshKey={refreshKey}
          onChange={bump}
        />
      </main>
    </div>
  );
}
